var _line, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline06Icuida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "timeline_06_icuida",
    xmlns: "http://www.w3.org/2000/svg",
    width: 284.937,
    height: 667,
    viewBox: "0 0 284.937 667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_42",
    "data-name": "L\\xEDnea 42",
    y2: 667,
    transform: "translate(141.646)",
    fill: "none",
    stroke: "#ce6854",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1252",
    "data-name": "Grupo 1252",
    transform: "translate(-920.354 -435.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1233",
    "data-name": "Grupo 1233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1229",
    "data-name": "Grupo 1229"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_81",
    "data-name": "Rect\\xE1ngulo 81",
    width: 284.937,
    height: 41.829,
    transform: "translate(920.354 927.599)",
    fill: "#ce6854"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Julio_2019",
    "data-name": "Julio 2019",
    transform: "translate(1006.544 958.09)",
    fill: "#fff",
    fontSize: 16.576,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Julio 2019"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1232",
    "data-name": "Grupo 1232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1230",
    "data-name": "Grupo 1230"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_197",
    "data-name": "Elipse 197",
    cx: 97.344,
    cy: 97.344,
    r: 97.344,
    transform: "matrix(0.162, -0.987, 0.987, 0.162, 952.806, 892.48)",
    fill: "#8ccee1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_198",
    "data-name": "Elipse 198",
    cx: 81.163,
    cy: 81.163,
    r: 81.163,
    transform: "translate(949.85 812.187) rotate(-45)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_06.",
    "data-name": 6,
    transform: "translate(984.313 750.313)",
    fill: "#00334e",
    fontSize: 36.479,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "06."))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1231",
    "data-name": "Grupo 1231"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Presentaci\\xF3n_web_app_",
    "data-name": "Presentaci\\xF3n web app ",
    transform: "translate(991.474 797.183)",
    fontSize: 25.097,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "Presentaci\xF3n "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 53.117
  }, "web app "))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1251",
    "data-name": "Grupo 1251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1234",
    "data-name": "Grupo 1234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_870",
    "data-name": "Trazado 870",
    d: "M1046.587,768.882a1.877,1.877,0,0,1,1.971-1.851,1.834,1.834,0,0,1,1.97,1.777,1.973,1.973,0,0,1-3.941.074Zm.419,4.022h3.079v13.179h-3.079Z",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_871",
    "data-name": "Trazado 871",
    d: "M1053.311,777.445c0-5.158,3.941-8.884,9.237-8.884a8.728,8.728,0,0,1,6.823,2.887l-2.069,1.95a6.053,6.053,0,0,0-4.607-2.024,6.072,6.072,0,1,0,0,12.142,5.991,5.991,0,0,0,4.607-2.048l2.069,1.974a8.743,8.743,0,0,1-6.848,2.888C1057.252,786.33,1053.311,782.6,1053.311,777.445Z",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_872",
    "data-name": "Trazado 872",
    d: "M1084.641,772.9v13.179h-2.932v-1.678a5.369,5.369,0,0,1-4.236,1.851c-3.375,0-5.666-1.851-5.666-5.825V772.9h3.079v7.108c0,2.393,1.133,3.529,3.079,3.529,2.143,0,3.6-1.333,3.6-3.973V772.9Z",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_873",
    "data-name": "Trazado 873",
    d: "M1088.383,768.882a1.877,1.877,0,0,1,1.971-1.851,1.835,1.835,0,0,1,1.97,1.777,1.973,1.973,0,0,1-3.941.074Zm.419,4.022h3.079v13.179H1088.8Z",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_874",
    "data-name": "Trazado 874",
    d: "M1108.925,767.771v18.312h-2.956v-1.7a5.422,5.422,0,0,1-4.36,1.876,6.751,6.751,0,0,1,0-13.5,5.383,5.383,0,0,1,4.237,1.777v-6.762Zm-3.03,11.723a3.922,3.922,0,1,0-3.916,4.121A3.848,3.848,0,0,0,1105.9,779.494Z",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_875",
    "data-name": "Trazado 875",
    d: "M1124.1,778.358v7.725h-2.906v-1.6c-.739,1.135-2.168,1.777-4.138,1.777-3.005,0-4.9-1.654-4.9-3.949,0-2.2,1.478-3.924,5.468-3.924h3.4v-.2c0-1.8-1.083-2.862-3.276-2.862a6.5,6.5,0,0,0-3.99,1.308l-1.207-2.246a9.237,9.237,0,0,1,5.567-1.629C1121.9,772.756,1124.1,774.558,1124.1,778.358Zm-3.079,3.6v-1.53h-3.177c-2.094,0-2.66.79-2.66,1.753,0,1.11.936,1.826,2.512,1.826A3.351,3.351,0,0,0,1121.017,781.961Z",
    fill: "#272425"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_82",
    "data-name": "Rect\\xE1ngulo 82",
    width: 77.081,
    height: 77.066,
    rx: 4.636,
    transform: "translate(1046.662 685.191)",
    fill: "#8ccee1",
    stroke: "#8ccee1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.327
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1250",
    "data-name": "Grupo 1250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1237",
    "data-name": "Grupo 1237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1235",
    "data-name": "Grupo 1235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_876",
    "data-name": "Trazado 876",
    d: "M1058.356,754.633l3.453-1.7c4.3-2.506,5.793-.152,6.427-.037,4.871.878,16.362,3.858,19.282,3.6s17.831-5.917,19.405-7.336a117.545,117.545,0,0,0,8.292-9.253h0c1.021-1.209,2.593-3.161,2.6-3.81a1.031,1.031,0,0,0-.679-1.083c-1.875-.9-3.932.64-6.613,2.807-.934.755-6.486,5.273-6.73,5.409,1.014,1.274,1.224,3.479-1.491,4.092a16.13,16.13,0,0,1-1.727.2c-.928.1-1.86.2-2.788.316-.726.1-1.452.223-2.173.354-.579.1-1.156.213-1.729.351a8.058,8.058,0,0,1-1.476.4,29.591,29.591,0,0,1-4.65-.867c.83-.041,1.667-.018,2.5-.07a11.529,11.529,0,0,0,2.728-.182c.62-.164,8.98-1.576,9.063-1.519,2.658-.435.7-3.125-.2-3.439-.624-.285-4.533-2.464-11.963-1.238-1.109.182-2.152.125-3.225.219a7.282,7.282,0,0,1-2.008-.213,3.331,3.331,0,0,1-1.5-.532c-6.806-5.984-10.843-5.414-11.359-5.478-.934-.12-9.183,1.9-16.312,6.439-.716.484-2.679,1.16-3.252,2.225Zm56.859-14.72",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.134
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_877",
    "data-name": "Trazado 877",
    d: "M1116.956,736.058c-.03.113-.289.824-2.421,3.345l-.009.012a117.65,117.65,0,0,1-8.208,9.165c-.535.482-3.781,1.995-8.951,3.952a62.489,62.489,0,0,1-10,3.185c-1.862.163-7.926-1.184-12.8-2.266-2.387-.53-4.642-1.03-6.222-1.317h0c-.054-.032-.156-.1-.233-.154-.937-.645-2.885-1.985-6.756.262h0l-1.843.9a1.127,1.127,0,0,1-1.468-.439l-4.551-7.683a.872.872,0,0,1,.291-1.186c.37-.227.779-.432,1.108-.6a9.2,9.2,0,0,0,.936-.512c6.872-4.373,14.858-6.359,15.794-6.316h0a3.125,3.125,0,0,0,.314.012c3.09.023,6.662,1.8,10.617,5.276l.009.008a3.781,3.781,0,0,0,1.785.689l.077.015a7.911,7.911,0,0,0,2.225.225c.4-.035.786-.048,1.2-.061a15.755,15.755,0,0,0,2.086-.165c3.086-.51,7.561-.731,11.357,1.1.063.031.115.055.154.073.022.01.043.019.066.027a2.276,2.276,0,0,1,1.014,1.548c-.01.095-.106.267-.636.362h0c-.25.015-.657.079-1.4.2-.771.122-1.828.295-2.975.488-1.593.268-4.4.75-4.8.858a5.353,5.353,0,0,1-1.638.145c-.3-.005-.6-.011-.937.012-.43.027-.858.033-1.311.039-.37.005-.752.011-1.133.029a.816.816,0,0,0-.772.625.788.788,0,0,0,.573.927,28.277,28.277,0,0,0,4.876.89,3.984,3.984,0,0,0,1.157-.27c.168-.059.326-.114.47-.149.488-.117,1.022-.225,1.686-.342.632-.114,1.38-.245,2.134-.348.833-.107,1.686-.2,2.511-.285l.26-.028c.167-.018.336-.032.5-.047a9.85,9.85,0,0,0,1.312-.17,3.284,3.284,0,0,0,2.64-2.046,3.355,3.355,0,0,0-.266-2.625v-.009c.709-.559,2.183-1.745,5.343-4.309l.822-.667c2.572-2.079,4.364-3.39,5.777-2.713C1116.95,735.842,1116.96,735.876,1116.956,736.058Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.572
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1236",
    "data-name": "Grupo 1236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_878",
    "data-name": "Trazado 878",
    d: "M1117.479,734.309c-2.416-1.158-4.971.907-7.443,2.9l-.838.68c-1.487,1.207-5.424,4.4-5.812,4.673a.785.785,0,0,0-.266.274,2.881,2.881,0,0,0-.966-.7l-.1-.048c-4.165-2.014-8.984-1.785-12.292-1.239a14.533,14.533,0,0,1-1.884.145c-.416.014-.846.028-1.283.066a6.648,6.648,0,0,1-1.789-.2l-.079-.015a2.805,2.805,0,0,1-1.064-.34c-4.244-3.731-8.158-5.636-11.633-5.662-.064,0-.114,0-.15,0-1.209-.134-9.6,1.959-16.819,6.556l-.018.012a8.212,8.212,0,0,1-.772.416,6.08,6.08,0,0,0-2.732,2.088.791.791,0,0,0,.016.777l6.124,10.339a.782.782,0,0,0,1.019.305l3.453-1.7.05-.026c3.03-1.767,4.329-.874,5.106-.34a2.04,2.04,0,0,0,.789.4c1.55.28,3.816.783,6.215,1.316,5.131,1.139,10.425,2.315,12.813,2.314.168,0,.322-.005.461-.017,3.1-.275,18.134-5.978,19.861-7.536a116,116,0,0,0,8.37-9.334c2.767-3.274,2.78-3.941,2.786-4.291A1.814,1.814,0,0,0,1117.479,734.309Zm-14.06,8.237-.027.016Zm14.4-6.443c-.012.649-1.584,2.6-2.6,3.81a117.545,117.545,0,0,1-8.292,9.253c-1.574,1.419-16.487,7.078-19.405,7.336s-14.411-2.725-19.282-3.6c-.634-.115-2.13-2.469-6.427.037l-2.29,1.125a1.4,1.4,0,0,1-1.825-.546l-4.7-7.938a1.831,1.831,0,0,1,.64-2.516c.7-.409,1.461-.729,1.851-.992,7.129-4.539,15.378-6.559,16.312-6.439.516.064,4.553-.506,11.359,5.478a3.331,3.331,0,0,0,1.5.532,7.282,7.282,0,0,0,2.008.213c1.073-.094,2.116-.037,3.225-.219,7.43-1.226,11.339.953,11.963,1.238.9.314,2.858,3,.2,3.439-.083-.057-8.443,1.355-9.063,1.519a11.529,11.529,0,0,1-2.728.182c-.831.052-2.414-.76-2.5.07-.118,1.182,3.54.909,4.65.867a8.058,8.058,0,0,0,1.476-.4c.573-.138,1.15-.25,1.729-.351.721-.131,1.447-.256,2.173-.354.928-.12,1.86-.217,2.788-.316a16.13,16.13,0,0,0,1.727-.2c2.715-.613,2.505-2.818,1.491-4.092.244-.136,5.8-4.654,6.73-5.409,2.681-2.167,4.738-3.706,6.613-2.807A1.031,1.031,0,0,1,1117.82,736.1Z",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.449
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_879",
    "data-name": "Trazado 879",
    d: "M1071.7,736.412h0Zm45.335-.324v0Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.112
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1249",
    "data-name": "Grupo 1249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1241",
    "data-name": "Grupo 1241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1239",
    "data-name": "Grupo 1239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1238",
    "data-name": "Grupo 1238"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_43",
    "data-name": "L\\xEDnea 43",
    x1: 6.454,
    transform: "translate(1063.121 709.056)",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.649
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_44",
    "data-name": "L\\xEDnea 44",
    x1: 4.564,
    y1: 4.583,
    transform: "translate(1067.33 690.572)",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.649
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1240",
    "data-name": "Grupo 1240"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_45",
    "data-name": "L\\xEDnea 45",
    x1: 4.564,
    y2: 4.583,
    transform: "translate(1067.33 722.951)",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.649
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1244",
    "data-name": "Grupo 1244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1242",
    "data-name": "Grupo 1242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_880",
    "data-name": "Trazado 880",
    d: "M1085.222,720.483l-1.726-1.727c-6.405-5.69-10.591-9.526-10.591-14.231a6.7,6.7,0,0,1,6.771-6.8,7.388,7.388,0,0,1,5.546,2.6,7.387,7.387,0,0,1,5.546-2.6,6.7,6.7,0,0,1,6.772,6.8c0,4.7-4.187,8.541-10.592,14.231Zm0,0",
    fill: "#ce6854"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1243",
    "data-name": "Grupo 1243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_881",
    "data-name": "Trazado 881",
    d: "M1085.026,720.432l-1.726-1.727c-6.405-5.69-10.591-9.526-10.591-14.231a6.7,6.7,0,0,1,6.771-6.8,7.39,7.39,0,0,1,5.546,2.6,7.391,7.391,0,0,1,5.546-2.6,6.7,6.7,0,0,1,6.772,6.8c0,4.705-4.187,8.541-10.592,14.231Zm0,0",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.649
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1248",
    "data-name": "Grupo 1248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1246",
    "data-name": "Grupo 1246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1245",
    "data-name": "Grupo 1245"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_46",
    "data-name": "L\\xEDnea 46",
    x2: 6.454,
    transform: "translate(1100.478 709.056)",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.649
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_47",
    "data-name": "L\\xEDnea 47",
    y1: 4.583,
    x2: 4.564,
    transform: "translate(1098.159 690.572)",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.649
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1247",
    "data-name": "Grupo 1247"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_48",
    "data-name": "L\\xEDnea 48",
    x2: 4.564,
    y2: 4.583,
    transform: "translate(1098.159 722.951)",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.649
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline06Icuida);
export default __webpack_public_path__ + "static/media/timeline_06_icuida.544da8fcac1638ec144b0cf0b5b21a71.svg";
export { ForwardRef as ReactComponent };